import Vue from 'vue';

// export const getTopicRepos = (topic) => {
//   return state.topics[topic].map((repoName) => {
//     return state.repos[repoName];
//   })
// };

// export const getCapitalRepos = (capital) => {
//   if (capital === 'All') {
//     return state.repos;
//   }
//   return Object.values(state.repos).filter((repo) => {
//     return repo.name.startsWith(capital);
//   });
// };

export const getRepos = (state) => {
  let capitalRepos;
  const capital = state.curCapital;
  const topics = state.curTopics;
  
  if (capital === 'All') {
    capitalRepos = Object.keys(state.repos);
  } else {
    capitalRepos = Object.keys(state.repos).filter((repoName) => {
      return repoName.toUpperCase().startsWith(capital);
    });
  }

  return topics.reduce((repos, curTopic) => {
    if (!state.topics.hasOwnProperty(curTopic)) {
      return [];
    }
    return repos.filter((repo) => state.topics[curTopic].includes(repo));
  }, capitalRepos);
};

export const getRepo = (state) => (repoName) => {
  return state.repos[repoName];
};


// WEBPACK FOOTER //
// ./src/store/getters.js